import { forwardRef } from "react";

// Form controls — calm surface + hairline that lifts to brand on focus (focus
// ring in primitives.css). Field wraps a labelled control; Input/Textarea/Select
// are the raw controls. Every control clears a 44px+ touch target.
export function Field({ label, htmlFor, className = "", style, children }) {
  return (
    <div className={`bz-field ${className}`.trim()} style={style}>
      {label && <label className="bz-field__label" htmlFor={htmlFor}>{label}</label>}
      {children}
    </div>
  );
}

// forwardRef — editor denníka (Journal.jsx) potrebuje po uložení vrátiť fokus do poľa
export const Input = forwardRef(function Input({ className = "", ...rest }, ref) {
  return <input ref={ref} className={`bz-input ${className}`.trim()} {...rest} />;
});

export const Textarea = forwardRef(function Textarea({ className = "", ...rest }, ref) {
  return <textarea ref={ref} className={`bz-textarea ${className}`.trim()} {...rest} />;
});

export const Select = forwardRef(function Select({ className = "", children, ...rest }, ref) {
  return <select ref={ref} className={`bz-select ${className}`.trim()} {...rest}>{children}</select>;
});
